import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const InstructionsPage = () => {
  const [agreed, setAgreed] = useState(false);
  const navigate = useNavigate();

  const handleProceed = () => {
    if (agreed) {
      navigate('/services/counselling/registration');
    }
  };

  return (
    <div className="container contentmid">
      {/* Steps Image */}
      <div id="tr4StepImg" className="text-center">
        <img 
            src="/assets/cuet-mock/images/step4_JEE.png" 
            id="ctl00_ContentPlaceHolder1_ctl00_imgstep" 
            className="img-responsive center-block" 
            alt="Steps"
            style={{margin: '0 auto'}}
        />
        <br />
      </div>

      <div>
        <h4>
            Instructions and Procedure for online submission of Application Form
            <br /><br />
            <span id="ctl00_ContentPlaceHolder1_lblheading">ऑनलाइन आवेदन पत्र जमा करने के दिशा निर्देश और प्रक्रिया</span>
        </h4>

        <div className="table-responsive">
          <table width="100%">
            <tbody>
              <tr>
                <td colspan="2" align="center">
                  <br /><br /><br />
                  <a 
                    className="btn btn-warning" 
                    href="https://cdnbbsr.s3waas.gov.in/s3d1a21da7bca4abff8b0b61b87597de73/uploads/2026/01/202601031633478370.pdf" 
                    target="_blank" 
                    rel="noreferrer"
                  >
                    Download Information Bulletin
                  </a>
                  <br /><br />
                </td>
              </tr>

              <tr>
                <td style={{ padding: '0px 5px' }}>
                  <div className="table-responsive">
                    <table style={{ width: '100%' }} className="table-borderless">
                      <tbody>
                        {/* Point 1 */}
                        <tr>
                          <td align="center" valign="top" width="30">1.</td>
                          <td align="left">
                            <span style={{ color: 'rgb(51, 51, 51)', fontFamily: '"Open Sans"', fontSize: '14px' }}>
                              <strong>Before filling the application form, download and read carefully the Information Bulletin. Also, read the instructions/ procedure given below and visit the course-wise list offered by the various participating Universities in the CUET-UG examination at https://cuet.nta.nic.in/ under University Tab.</strong>
                            </span>
                            <br />
                            <span style={{ color: 'rgb(51, 51, 51)', fontFamily: '"Open Sans"', fontSize: '14px' }}>
                              <strong>आवेदन पत्र भरने से पहले, सूचना बुलेटिन डाउनलोड करें और पढ़ें। साथ ही, नीचे दिए गए निर्देश/प्रक्रिया को ध्यान से पढ़ें और https://cuet.nta.nic.in/ पर यूनिवर्सिटी टैब के अंतर्गत सीयूईटी (यूजी) परीक्षा में भाग लेने वाले विभिन्न विश्वविद्यालयों द्वारा प्रस्तुत पाठ्यक्रम की सूची देखें।</strong>
                            </span>
                          </td>
                        </tr>

                        {/* Point 2 */}
                        <tr>
                          <td align="center" valign="top">2.</td>
                          <td align="left">
                            You can apply for CUET (UG)-2026 ‘ON-LINE’ only through the official website of CUET (UG) 2026 (https://cuet.nta.nic.in).
                            <br />
                            अभ्यर्थी सीयूईटी (यूजी) 2026 के लिए ‘ऑन-लाइन ’ आवेदन केवल सीयूईटी (यूजी) 2026 की आधिकारिक वेबसाइट: https://cuet.nta.nic.in के माध्यम से ही कर सकते हैं।
                          </td>
                        </tr>

                        {/* Point 3 - Fee Table */}
                        <tr>
                          <td align="center" valign="top">3.</td>
                          <td align="left">
                            <strong>Examination Fees <br />परीक्षा शुल्क</strong>
                          </td>
                        </tr>
                        <tr>
                          <td>&nbsp;</td>
                          <td>
                            <table className="table table-bordered table-condensed" style={{ width: '100%' }}>
                              <tbody>
                                <tr className="bg-info">
                                  <th>Category</th>
                                  <th>Up to 03 Subjects</th>
                                  <th>For each Additional Subject</th>
                                </tr>
                                <tr align="left"><td>General (UR)</td><td>₹ 1000/-</td><td>₹ 400/- (each)</td></tr>
                                <tr align="left"><td>OBC- (NCL) / EWS</td><td>₹ 900/-</td><td>₹ 375/- (each)</td></tr>
                                <tr align="left"><td>SC / ST / PwD / PwBD / Third gender</td><td>₹ 800/-</td><td>₹ 350/- (each)</td></tr>
                                <tr align="left"><td>Centres outside India</td><td>₹ 4500/-</td><td>₹ 1800/- (each)</td></tr>
                                <tr align="center">
                                  <td colspan="3">
                                    <br />
                                    <div>Service Charges & GST (as applicable) will be charged extra by the Bank. <br />सेवा शुल्क और जीएसटी (लागू होने पर) बैंक द्वारा अतिरिक्त शुल्क लिया जाएगा।</div>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>

                        {/* Point 4 - Application Procedure */}
                        <tr>
                          <td align="center" valign="top">4.</td>
                          <td align="left">
                            <strong>Application Procedure: 3 simple Steps to be followed to apply online <br />आवेदन प्रक्रिया: ऑनलाइन आवेदन करने के लिए 3 सरल चरणों का पालन किया जाना चाहिए।</strong>
                            <br /><br />
                            Candidates must read carefully the Instructions (including how to fill up Application Form online) given in the Information Bulletin available on the NTA Website. Candidates not complying with the Instructions shall be summarily disqualified.
                            <br />
                            अभ्यर्थियों को एनटीए वेबसाइट पर उपलब्ध सूचना विवरणिका में दिए गए निर्देशों (ऑनलाइन आवेदन पत्र को भरने सहित) को ध्यान से पढ़ना चाहिए। निर्देशों का पालन नहीं करने वाले अभ्यर्थियों को अयोग्य घोषित कर दिया जाएगा।
                          </td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">&nbsp;</td>
                          <td align="left">
                            <table cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
                              <tbody>
                                <tr>
                                  <td valign="top" width="8%"><strong>Step 1:</strong></td>
                                  <td>
                                    <strong>Register for Online Application Form</strong> and note down system generated <strong>Application Number</strong>. The candidate should supply the required details while filling the Online Application Form and is also required to create PASSWORD and choose Security Question and enter his/her Answer. After successful submission of the personal details, Application number will be generated and it will be used to complete the remaining Steps of the Application Form and will also be required for all future reference/ correspondence. For subsequent logins, candidate will be able to login directly with the respective system generated <strong>Application Number</strong> and created <strong>Password.</strong>
                                    <br />
                                    <strong>चरण 1: ऑनलाइन आवेदन पत्र के लिए पंजीकरण करें और प्राप्त आवेदन संख्या नोट करें:</strong> अभ्यर्थी ऑनलाइन आवेदन पत्र भरते समय आवश्यक विवरणों को प्रविष्ट करें जो कुंजिका बनाने, उससे संबंधित सुरक्षा प्रश्न चुनने और उसका उत्तर दर्ज करने के लिए आवश्यक है। व्यक्तिगत विवरणों को सफलतापूर्वक प्रस्तुत करने के बाद, आवेदन संख्या प्राप्त होगी जिसका उपयोग आवेदन पत्र के शेष चरणों को पूरा करने के लिए किया जाएगा और जो भविष्य के सभी संदर्भ/पत्राचार के लिए भी आवश्यक होगा। लॉग इन करने के लिए अभ्यर्थी संबंधित सिस्टम जनित आवेदन संख्या एवं स्वयं बनाई हुई कुंजिका से लॉग इन कर सकेगें।
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top"><strong>Step 2:</strong></td>
                                  <td valign="top">
                                    <strong>Complete the Application Form</strong> Candidate can login with the system generated Application Number and created Password for completing the Application Form.
                                    <br />
                                    <strong>चरण 2: आवेदन पत्र पूरा करें-:</strong> अभ्यर्थी सिस्टम जनित आवेदन संख्या एवं कुंजिका से लॉग इन करके आवेदन पत्र को पूरा कर सकते हैं।
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">&nbsp;</td>
                                  <td valign="top">
                                    <strong>Upload Scanned Images of Candidate’s Photograph, Signature, Identity Proof (wherever applicable) and PwD/PwBD/UDID Certificate (wherever applicable) :</strong>
                                    <br />
                                    <strong>अभ्यर्थी की फोटो , हस्ताक्षर, पहचान प्रमाण (जहां लागू हो) और दिव्यांगजन प्रमाणपत्र (जहां लागू हो) की स्कैन की गई छवियां अपलोड करें:</strong>
                                    <ol style={{ listStyleType: 'lower-roman' }}>
                                      <li>
                                        <strong>The recent passport size photograph should be in colour with 80% face (without mask) visible including ears against white background. Photograph in JPG/JPEG format (clearly legible) between 10 kb to 200 kb.</strong>
                                        <br />
                                        <strong>हाल में खींची गई पासपोर्ट आकार की फोटो (रंगीन एवं सफेद पृष्ठभूमि के साथ)जिसमें कानों के साथ-साथ 80% चेहरा साफ दिखाई देना चाहिए (मास्क के बिना)। तस्वीर की फ़ाइल JPG/JPEG प्रारूप (स्पष्ट रूप से सुपाठ्य) और 10 kb से 200 kb के बीच होना चाहिए।</strong>
                                        <br /><br />
                                      </li>
                                      <li>
                                        Signature file should be JPG/JPEG format (clearly legible) between <strong>10 kb to 50 kb</strong>.
                                        <br />
                                        हस्ताक्षर की फ़ाइल का प्रारूप JPG/JPEG (स्पष्ट रूप से सुपाठ्य) और <strong>10 kb से 50 kb</strong> के बीच होना चाहिए।
                                        <br /><br />
                                      </li>
                                      <li>
                                        Scanned copy of Identity Proof (for those candidates who will verify their identities through methods other than Aadhaar or DigiLocker) should be in format JPG/JPEG between <strong>10 kb to 200 kb</strong> (clearly legible).
                                        <br />
                                        पहचान प्रमाण की स्कैन की गई कॉपी का प्रारूप JPG/JPEG (स्पष्ट रूप से सुपाठ्य) और आकार <strong>10 kb से 200 kb</strong> के बीच होना चाहिए।
                                        <br /><br />
                                      </li>
                                      <li>
                                        Scanned copy of Disability/UDID certificate should be a pdf between <strong>50 kb to 300 kb</strong> (clearly legible).
                                        <br />
                                        दिव्यांगजन प्रमाण पत्र की स्कैन की गई प्रति का प्रारूप pdf और आकार <strong>50 kb से 300 kb</strong> के बीच होना चाहिए।
                                      </li>
                                    </ol>
                                    <strong>
                                      [Note: The Candidate has to upload only his/ her own photograph, signature, and certificate(s) as mentioned above (and not of anybody else) in a correct/proper manner, as the facility for correction will not be given in the future.]
                                    </strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top"><strong>Step 3:</strong></td>
                                  <td colspan="2">
                                    The candidate has to select Debit card/Credit card/UPI/Net banking option to pay the application fee and follow the online instruction to complete the payment of fee.
                                    <br />
                                    चरण 3: अभ्यर्थी को आवेदन शुल्क का भुगतान करने के लिए डेबिट कार्ड/क्रेडिट कार्ड/यूपीआई/नेट बैंकिंग विकल्प का चयन करना होगा।
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>

                        {/* Point 5 - Password */}
                        <tr>
                          <td align="center" valign="top">5.</td>
                          <td align="left">
                            <strong>Important Instruction about PASSWORD <br />कुंजिका के बारे में महत्वपूर्ण निर्देश:</strong>
                          </td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">&nbsp;</td>
                          <td align="left">
                            <table cellspacing="0" cellpadding="0">
                              <tbody>
                                <tr>
                                  <td valign="top">
                                    <ol>
                                      <li>During online form filling, candidate will be required to choose PASSWORD and Security Question and its Answer.</li>
                                      <li>For subsequent logins, candidate will be able to login directly with their respective system generated Application Number and the chosen Password.</li>
                                      <li>Candidate is advised not to disclose or share their password with anybody.</li>
                                      <li>Candidate can change his/her passwords after login, if desired.</li>
                                      <li>Candidate should remember to log out at the end of their session.</li>
                                    </ol>
                                  </td>
                                </tr>
                                <tr>
                                  <td valign="top">The Password must be as per the following Password policy.<br />कुंजिका निम्नलिखित कुंजिका-पॉलिसी के अनुसार होना चाहिए।</td>
                                </tr>
                                <tr>
                                  <td>
                                    <ol>
                                      <li>Password must be 8 to 13 character long.</li>
                                      <li>Password must have at least one Upper case alphabet.</li>
                                      <li>Password must have at least one Lower case alphabet.</li>
                                      <li>Password must have at least one numeric value.</li>
                                      <li>Password must have at least one special characters eg.!@#$%^&amp;*-.</li>
                                    </ol>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>

                        {/* Point 6 & 7 */}
                        <tr>
                          <td align="center" valign="top">6.</td>
                          <td align="left">
                            <strong>How to reset your Password : </strong>The following options are available to reset Password.
                            <br />
                            अपना कुंजिका कैसे रीसेट करें: कुंजिका रीसेट करने के लिए निम्नलिखित विकल्प उपलब्ध हैं.
                          </td>
                        </tr>
                        <tr>
                            <td align="center" valign="top"></td>
                            <td>
                                <ol>
                                    <li>Using Security Question & its Answer you have chosen during Form filling.</li>
                                    <li>Using a verification code sent via text message (SMS) to your Registered Mobile No.</li>
                                    <li>Using a reset link sent via Email to your Registered Email address.</li>
                                </ol>
                            </td>
                        </tr>
                        <tr>
                          <td align="center" valign="top">7.</td>
                          <td align="left">
                            The Application Number printed on the computer generated Confirmation Page must be mentioned in all such correspondences. It is therefore essential to note down the application number printed on the Confirmation Page.
                            <br />
                            कंप्यूटर जनित पुष्टि-पृष्ठ पर मुद्रित आवेदन संख्या का उल्लेख सभी पत्राचार में किया जायेगा। इसलिए पुष्टि-पृष्ठ पर मुद्रित आवेदन संख्या को दर्ज़/नोट करना आवश्यक है।
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>

              <tr>
                <td height="10px;"></td>
              </tr>

              <tr>
                <td>
                  <hr class="line" />
                  <p class="text-primary" style={{ textAlign: 'center' }}>
                    <strong>Please read the instructions carefully and give your consent for below mentioned declaration</strong>
                  </p>
                </td>
              </tr>

              {/* Checkbox Section */}
              <tr>
                <td className="bg-warning" style={{ padding: '15px' }}>
                  <div className="checkmark" style={{ display: 'flex', alignItems: 'flex-start' }}>
                    <input
                      id="chkagreement"
                      type="checkbox"
                      checked={agreed}
                      onChange={(e) => setAgreed(e.target.checked)}
                      style={{ marginTop: '5px' }}
                    />
                    <label htmlFor="chkagreement" style={{ marginLeft: '10px', fontWeight: 'bold' }}>
                      <span className="text-danger">
                        <strong>
                          <p>
                            I have downloaded the Information Bulletin of CUET (UG) 2026, read and understood all the Instructions therein as well as those mentioned above, and will fill up the online Application Form for the CUET (UG) 2026 accordingly.
                          </p>
                          <p>
                            मैंने सीयूईटी (यूजी) 2026 के सूचना बुलेटिन को डाउनलोड कर लिया है, उसमें दिए गए सभी निर्देशों के साथ-साथ ऊपर वर्णित सभी निर्देशों को पढ़ और समझ लिया है, और तदनुसार सीयूईटी (यूजी) 2026 के लिए ऑनलाइन आवेदन पत्र भर रहा / रही हूँ|
                          </p>
                        </strong>
                      </span>
                    </label>
                  </div>
                </td>
              </tr>

              {/* Submit Button */}
              <tr>
                <td align="center" colspan="2" height="10px;">
                  <br />
                  <input
                    type="submit"
                    value="Click here to Proceed"
                    id="btnsubmit"
                    className={`btn btn-primary btn-lg ${!agreed ? 'disabled' : ''}`}
                    disabled={!agreed}
                    onClick={handleProceed}
                    style={{ width: '250px' }}
                  />
                </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InstructionsPage;